import { UPDATE_LOAD_PAYMENT, RESET_LOAD_PAYMENT } from "./actionTypes";
import * as Yup from "yup";
const load_paymentBase = {
  id: "",
  amount: "",
  concept: "",
  load_id: '',
};

const initialState = {
  load_payment: { ...load_paymentBase },
  load_paymentValidations: {
    concept: Yup.string().required('Concept payment is required'),
    amount: Yup.number().required('Amount payment is required')
  },
};

const load_payment = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_LOAD_PAYMENT:
      // Actualizar el estado
      return {
        ...state,
        load_payment: action.payload,
      };
    case RESET_LOAD_PAYMENT:
      // Actualizar el estado
      return {
        ...state,
        load_payment: { ...load_paymentBase },
      };
    default:
      return state;
  }
};

export default load_payment;
